export const progressBarData = ({
  matchEligibleAmountCents,
  projectedMatchAmountCents,
  earnedMatchAmountCents,
  projectedMatchAmountColor,
  earnedMatchAmountColor,
}: {
  matchEligibleAmountCents: number;
  projectedMatchAmountCents: number;
  earnedMatchAmountCents: number;
  projectedMatchAmountColor: string;
  earnedMatchAmountColor: string;
}) => {
  const projectedMatchAmountPercent = (projectedMatchAmountCents / matchEligibleAmountCents) * 100;

  const projectMatchBarData = {
    percent: projectedMatchAmountPercent,
    indicatorColor: projectedMatchAmountColor,
  };

  const earnedMatchAmountPercent = (earnedMatchAmountCents / matchEligibleAmountCents) * 100;

  return [
    {
      percent: earnedMatchAmountPercent,
      indicatorColor: earnedMatchAmountColor,
    },
    projectMatchBarData,
  ];
};
